import { Injectable } from "@angular/core";
import moment from "moment";
import { DateUtils } from "../utils/date-utils";

@Injectable({
    providedIn: "root"
})
export class FormatService {

    /**
     * Denna metod bör ersättas med någon mer generell parsning av nummer via något bibliotek
     * Använd helst inte detta tills vi vet kraven.
     * Exempelvis så stöds konstig input => "1,5.5" => "15.5"
     */

    formatNumberToString(unknownInput: any): string {
        if (typeof unknownInput === "number") {
            unknownInput = unknownInput.toString();
        }

        // Remove all none number chars
        let value = unknownInput.replace(/[^\d\s,.-]/g, "");
        value = value.trim();

        let antalPunkter = 0;
        let antalKomman = 0;

        if (unknownInput.indexOf(".") > -1) {
            antalPunkter = (unknownInput.match(/\./g) || []).length;
        }

        if (unknownInput.indexOf(",") > -1) {
            antalKomman = (unknownInput.match(/,/g) || []).length;
        }

        if (antalPunkter === 0) {
            if (antalKomman === 1) {
                value = value.replace(/,/g, ".");
            } else {
                value = value.replace(/,/g, "");
            }
        } else if (antalPunkter === 1) {
            value = value.replace(/[^\d.-]/g, "");
        } else {
            if (antalKomman === 0) {
                value = value.replace(/./g, "");
            } else if (antalKomman === 1) {
                value = value.replace(/./g, "");
                value = value.replace(/,/g, ".");
            } else {
                value = value.replace(/[^\d-]/g, "");
            }
        }

        value = value.trim();
        value = value.replace(/\s/g, "");

        return value;
    }

    dateFormatRask(inputdate: string | Date, monthYearOnly: boolean): string {
        // eslint-disable-next-line sonarjs/no-selector-parameter
        if (monthYearOnly) {
            let date = moment(inputdate).format("MMMM YYYY");
            date = date[0].toUpperCase() + date.substring(1);
            return date;
        } else {
            return moment(inputdate).format(DateUtils.dateformat);
        }
    }

    dateFormatRange(start: string, end: string) {
        return `${this.dateFormatRask(start, false)} - ${end ? this.dateFormatRask(end, false) : ""}`;
    }

    stringToBoolean(val) {
        if (val == null || val === "") {
            return null;
        }
        return val === "true" ? true : false;
    }

    booleanToString(val) {
        if (val == null) {
            return "";
        }
        return val ? "true" : "false";
    }
}
